module.exports = __webpack_public_path__ + "static/media/icon-location-off.ab068c84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-location-off.svg
// module id = 664
// module chunks = 0